import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ActionSheetController,
  App,
  NavController,
  PopoverController,
  Searchbar,
  ToastController
} from 'ionic-angular';
import * as _ from 'lodash';
import { StatisticPage } from '../../pages';
import { ApiProvider, ChainNetwork } from '../../providers/api/api';
import { CurrencyProvider } from '../../providers/currency/currency';
import { Logger } from '../../providers/logger/logger';
import { PriceProvider } from '../../providers/price/price';
import { RedirProvider } from '../../providers/redir/redir';
import { SearchProvider } from '../../providers/search/search';
import { DenominationComponent } from '../denomination/denomination';

@Component({
  selector: 'head-nav',
  templateUrl: 'head-nav.html'
})
export class HeadNavComponent implements OnInit {
  @ViewChild('searchbar') searchbar: Searchbar;
  public showSearch = false;
  public loading: boolean;
  @Input()
  public title: string;
  @Input()
  public chainNetwork: ChainNetwork;
  @Input()
  public currentPage: string;
  @Input()
  public currentCurrency: string;
  public q: string;
  public redirTo: any;
  public params: any;

  constructor(
    public app: App,
    public currencyProvider: CurrencyProvider,
    public priceProvider: PriceProvider,
    public actionSheetCtrl: ActionSheetController,
    public popoverCtrl: PopoverController,
    public toastCtrl: ToastController,
    public searchProvider: SearchProvider,
    public redirProvider: RedirProvider,
    private navCtrl: NavController,
    private logger: Logger,
    private apiProvider: ApiProvider
  ) {}

  public ngOnInit(): void {
    this.params = {
      chain: this.chainNetwork.chain,
      network: this.chainNetwork.network
    };
  }

  // function for navigation
  public openPage(page: string): void {
    if (page === 'home') {
      this.navCtrl.setRoot('home', this.params);
    } else {
      this.navCtrl.push(page, this.params);
    }
  }

  public search(): void {
    this.q = this.q.replace(/\s/g, '');
    this.searchProvider
      .isInputValid(this.q, this.chainNetwork)
      .subscribe(inputDetails => {
        if (this.q !== '' && inputDetails.isValid) {
          this.showSearch = false;
          this.searchProvider
            .search(this.q, inputDetails.type, this.chainNetwork)
            .subscribe(
              res => {
                const nextView = this.processResponse(res);
                if (!_.includes(nextView, '')) {
                  this.params[nextView.type] = nextView.params;
                  this.redirTo = nextView.redirTo;
                  this.navCtrl.setRoot('home', this.params, { animate: false });
                  this.redirProvider.redir(this.redirTo, this.params);
                } else {
                  const message = 'No matching records found!';
                  this.wrongSearch(message);
                  this.logger.info(message);
                }
              },
              err => {
                this.wrongSearch('Server error. Please try again');
                this.logger.error(err);
              }
            );
        } else {
          this.wrongSearch('No matching records found!');
        }
      });
  }

  private processResponse(response) {
    if (response.addr) {
      return {
        redirTo: 'address',
        params: response.addr[0] ? response.addr[0].address : this.q,
        type: 'addrStr'
      };
    } else {
      return _.reduce(
        response,
        (result, value) => {
          if (value.tx) {
            result = {
              redirTo: 'transaction',
              params: value.tx.txid,
              type: 'txId'
            };
          } else if (value.block) {
            result = {
              redirTo: 'block-detail',
              params: value.block.hash,
              type: 'blockHash'
            };
          }
          return result;
        },
        { redirTo: '', params: '', type: '' }
      );
    }
  }

  private wrongSearch(message: string): void {
    this.loading = false;
    this.presentToast(message);
    setTimeout(() => {
      this.searchbar.setFocus();
    }, 150);
  }

  private presentToast(message): void {
    const toast: any = this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  public changeCurrency(myEvent: any): void {
    const popover: any = this.popoverCtrl.create(DenominationComponent, {
      config: this.chainNetwork,
      currencySymbol: this.currencyProvider.getCurrency()
    });
    popover.present({
      ev: myEvent
    });
    popover.onDidDismiss(data => {
      if (!data) {
        return;
      } else if (data.config !== this.chainNetwork) {
        this.apiProvider.changeNetwork(data.config);
        this.setCurrency(data.config);
        const page = this.currentPage ? 'home' : 'statistic';
        this.navCtrl.setRoot(page, this.apiProvider.getConfig());
      } else if (data.currencySymbol !== this.currencyProvider.getCurrency()) {
        this.setCurrency(this.chainNetwork, data.currencySymbol);
      }
    });
  }

  private setCurrency(chainNetwork, currencySymbol?) {
    this.currencyProvider.setCurrency(chainNetwork, currencySymbol);
    this.priceProvider.setCurrency(currencySymbol);
  }

  public toggleSearch(): void {
    this.showSearch = !this.showSearch;
  }
}



// WEBPACK FOOTER //
// ./src/components/head-nav/head-nav.ts